<script setup>
import RetryFailedRequest from '@/components/widgets/RetryFailedRequest.vue';
import CircularLoader from '@/components/widgets/CircularLoader.vue';
import { ref } from 'vue';

const emits = defineEmits(['retry']);
defineProps({
    tabs: {
        type: Array,
        required: true
    },
    loading: {
        type: Boolean,
        default: false
    },
    showContent: {
        type: Boolean,
        default: false
    },
    showRetryButton: {
        type: Boolean,
        default: false
    },
    elevation: {
        type: Number,
        default: undefined
    },
    alignTabs: {
        type: String,
        default: 'center'
    },
    errorMessage: {
        type: String,
        default: ''
    }
});

const activeTab = ref(0);
</script>

<template>
    <v-card :elevation="elevation">
        <v-tabs v-model="activeTab" color="primary" :align-tabs="alignTabs">
            <v-tab v-for="(tab, index) in tabs" :key="index" :value="index">
                <v-icon class="me-2">{{ tab.icon }}</v-icon>
                <span class="tab-label">{{ $t(tab.label) }}</span>
            </v-tab>
        </v-tabs>

        <v-card-text v-if="showContent && !showRetryButton">
            <v-window v-model="activeTab">
                <v-window-item
                    v-for="(tab, index) in tabs"
                    :key="index"
                    :value="index"
                >
                    <slot :name="tab.slotName"></slot>
                </v-window-item>
            </v-window>
        </v-card-text>

        <CircularLoader v-if="loading"></CircularLoader>

        <v-card-text v-else-if="showRetryButton && showContent">
            <RetryFailedRequest
                :message="errorMessage"
                @retry="emits('retry')"
            ></RetryFailedRequest>
        </v-card-text>
    </v-card>
</template>

<style lang="scss" scoped>
:deep(.v-tab) {
    font-size: 0.75rem; /* 14px */
    text-transform: uppercase;
}
</style>
